import styled, { css } from "styled-components";
import Header from "../Header";

const MainLayout = ({ children, handleContinue, openDrawer, onSetDrawer, stage }) => {
  return (
    <div>
      <Header handleContinue={handleContinue} openDrawer={openDrawer} onSetDrawer={onSetDrawer} stage={stage}/>
      <Main>{children}</Main>
    </div>
  );
};
export default MainLayout;

const Main = styled.main`
${() => css`
  height: 100%;
  display: flex;

  @media (max-width: 991px) {
    flex-direction: column-reverse;
  }

  aside {
    flex: 1;

     @media (max-width: 991px) {
      order: -1;
    }
  }

  .stage-wrapper {
    flex-grow: 1;
  }

  
`}
  
`;
